/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { getConfigForPath } from './ApplicationConfigHelper';
import { useAppShellContext } from '../hooks/AppShellContext';

const ExternalAppRedirect = ({ url }) => {
  const { pathname } = useLocation();
  const dest = url + pathname;
  useEffect(() => {
    window.location.href = dest;
  });
  return <div />;
};

ExternalAppRedirect.propTypes = {
  url: PropTypes.string.isRequired
};

const MissingWrapper = ({ missing: Missing }) => {
  const location = useLocation();
  return Missing ? <Missing location={location} /> : null;
};

MissingWrapper.propTypes = {
  missing: PropTypes.func
};

const AppShellSwitch = ({ children, prefix, missing: Missing }) => {
  const applicationContext = useAppShellContext();
  const applications = getConfigForPath(applicationContext, prefix);

  const redirects = Object.entries(applications.redirects);
  const modulesInApp = Object.entries(applications.modules)
    .filter(([_, module]) => module?.render instanceof Function)
    .filter(([path, _]) => !prefix || !path.startsWith(prefix));
  const externalModules = Object.entries(applications.modules)
    .filter(([_, module]) => typeof module === 'string')
    .filter(([path, _]) => !prefix || !path.startsWith(prefix));

  return (
    <Switch>
      {/* Redirects - exact path */}
      {redirects.map(([path, redirect]) => (
        <Route key={path} exact path={path}>
          <Redirect to={redirect} />
        </Route>
      ))}

      {/* Modules within app */}
      {modulesInApp.map(([path, Module]) => (
        <Route key={path} path={path}>
          <Module config={applicationContext} />
        </Route>
      ))}

      {children}

      {/* External modules */}
      {externalModules.map(([path, module]) => (
        <Route key={path} path={path}>
          <ExternalAppRedirect url={module} />
        </Route>
      ))}

      <MissingWrapper missing={Missing} />
    </Switch>
  );
};

AppShellSwitch.propTypes = {
  children: PropTypes.node,
  missing: PropTypes.func,
  prefix: PropTypes.string
};

export default AppShellSwitch;
